$(document).ready(function () {
  jQuery(".footer h3").click(function () {
    $(this).toggleClass("tab_active");
  });
  $(".regular").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,    
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
});

class DesktopFiltersTrigger extends HTMLElement {
  constructor() {
    super();
    this.collectionFilters = this.parentElement.querySelector('#collectionFilters');
    this.addEventListener('click', () => {
      this.collectionFilters.classList.toggle('abz-desktop-filters-open');
      document.body.style.overflow = this.collectionFilters.classList.contains('abz-desktop-filters-open') ? 'hidden' : '';
      document.body.classList.toggle('abz-filters-overlay', this.collectionFilters.classList.contains('abz-desktop-filters-open'));
      
      // Add escape key listener when filters are opened
      if (this.collectionFilters.classList.contains('abz-desktop-filters-open')) {
        document.addEventListener('keydown', this.handleEscapeKey);
        document.addEventListener('click', this.handleOverlayClick);
      } else {
        document.removeEventListener('keydown', this.handleEscapeKey);
        document.removeEventListener('click', this.handleOverlayClick);
      }
    });

    // Bind the handlers to this instance
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
  }

  handleEscapeKey(e) {
    if (e.key === 'Escape') {
      this.collectionFilters.classList.remove('abz-desktop-filters-open');
      document.body.style.overflow = '';
      document.body.classList.remove('abz-filters-overlay');
      document.removeEventListener('keydown', this.handleEscapeKey);
      document.removeEventListener('click', this.handleOverlayClick);
    }
  }

  handleOverlayClick(e) {
    // Only close if clicking the overlay (not the filters panel)
    if (e.target.classList.contains('abz-filters-overlay')) {
      this.collectionFilters.classList.remove('abz-desktop-filters-open');
      document.body.style.overflow = '';
      document.body.classList.remove('abz-filters-overlay');
      document.removeEventListener('keydown', this.handleEscapeKey);
      document.removeEventListener('click', this.handleOverlayClick);
    }
  }
}

customElements.define('desktop-filters-trigger', DesktopFiltersTrigger);

class DesktopFiltersClose extends HTMLElement {
  constructor() {
    super();
    this.collectionFilters = this.closest('#collectionFilters');
    this.addEventListener('click', () => {
      this.collectionFilters.classList.remove('abz-desktop-filters-open');
      document.body.style.overflow = '';
      document.body.classList.remove('abz-filters-overlay');
      document.removeEventListener('keydown', this.handleEscapeKey);
      document.removeEventListener('click', this.handleOverlayClick);
    });
  }
}

customElements.define('desktop-filters-close', DesktopFiltersClose);